import * as CL from '@design-system/component-library';
import { dsClass } from '../../common/constants/dsClasses.js';
import { paths } from '../../common/constants/pathVariables.js';
import { t } from '../../common/i18n/index.js';
import { pictureStorageBaseUrl } from '../Picture/contentfulImageProxy.js';
import './KukaSoittaaHero.scss';

export const KukaSoittaaHero = () => {
  return (
    <div className="kukasoittaa-hero">
      <div className="hero-container">
        <div className="hero-content">
          <h1 className={dsClass.H1}>{t.EER5('Order the Elisa Kuka Soittaa service')}</h1>
          <p className={dsClass.TEXT_LARGE}>
            {t.I6X5(
              `With the Elisa Kuka Soittaa service, you can see who is calling you. The service automatically displays the caller's name on your phone without the need to download separate apps.`
            )}
          </p>
          <div className="hero-features">
            <p className={dsClass.TEXT_M}>
              {t.WBZV('Elisa Kuka Soittaa is now available at an introductory price:')}
              <br />
              <b>{t.UX5G('2,99 € / month / subscription, VAT 0%')}</b>
              <br />
              {t.PB2M('Regular price: 3,99 € / month / subscription, VAT 0%')}
            </p>
          </div>
          <div className="hero-link">
            <a href={paths.KUKASOITTAA} className="hero-learn-more">
              {t.AQOP('Read more about the Kuka Soittaa service')} <CL.Icon icon="arrow-right-alt" />
            </a>
          </div>
        </div>
        <div className="hero-image">
          <img
            src={`${pictureStorageBaseUrl}Wt3MaGPPsH5GPDgOxEHf4/eae7226c9d6b3839c7be9f60b60c0f7ebd156a66.png?w=600`}
            alt={t.FAKM('Elisa Caller ID service on phone')}
            className="img-fluid"
          />
        </div>
      </div>
    </div>
  );
};
